import * as React from 'react';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import { CardMedia, Typography, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import logo_white from './../assets/logo/logo_white.png'
import logo_dark from './../assets/logo/logo_dark.png'
import { useDarkMode } from '../context/DarkModeContext';

const Home = () => {
  const profile = JSON.parse(localStorage.getItem("user"));
  const { isDarkMode } = useDarkMode()
  const navigate = useNavigate();
  return (
    <Box sx={{ display: 'flex', width: '100%', height: '100dvh' }}>
      <CssBaseline />
      <Box component="main" sx={{ flexGrow: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column', height: '100%' }}>
          <Typography gutterBottom variant="h5" component="div">
              <bdi>{`Hi ${profile?.name}`}</bdi>
          </Typography>
          <CardMedia
            component={'img'}
            sx={{ width: 300, height: 'auto', objectFit: 'contain' }}
            src={isDarkMode ? logo_dark : logo_white}
          />
          <Button
            variant="contained"
            color="primary"
            sx={{ mt: 3, px: 4, py: 1.5, fontSize: '1.1rem' }}
            onClick={() => navigate('/programs')}
          >
            Go to Programs
          </Button>
        </Box>
      </Box>
    </Box>
  )
}

export default Home